import DesignerReport from '../DesignerReport';

export default new DesignerReport();
